import React from "react";// Optional: You can replace with your own icon or import as prop

interface WeightCardProps {
  label?: string;
  weight?: number;
  unit?: string;
  date?: Date;
  themeColor?: string; // Tailwind color like "red", "blue", "green"
  icon?: React.ReactNode;
}

const WeightCard: React.FC<WeightCardProps> = ({
  label = "Empty Weight",
  weight = 0,
  unit = "Tons",
  date = new Date(),
  themeColor = "red",
  icon,
}) => {
  const formattedDate = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);

  return (
    <div
      className={`rounded-xl border border-${themeColor}-300 bg-${themeColor}-50 px-4 py-3 flex flex-col sm:flex-row sm:items-center justify-between gap-2 w-full max-w-md shadow-sm`}
    >
      <div className="flex items-center gap-3">
        <div>
          <p className="text-sm text-gray-700">{label}</p>
        {icon ?? (
          <>🦣</>
        )}
        </div>
      </div>
      
      <div>
          <p className="text-xl font-bold text-gray-900">
            {weight} {unit}
          </p>
      <div className="text-sm italic text-gray-600">{formattedDate}</div>
      </div>
    </div>
  );
};

export default WeightCard;
